import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { InventoryTransferDetailModel } from 'src/app/models/inventory/inventory-transfer-detail.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { InventoryTransferDetailCaptureTableModel } from 'src/app/models/tables/inventory/inventory-transfer-detail-capture-table.model';
import { InventoryTransferDetailTableModel } from 'src/app/models/tables/inventory/inventory-transfer-detail-table.model';
import { RentalStockModalModel } from 'src/app/models/tables/rental/rental-stock-modal.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InventoryTransferDetailService {

  constructor(private _httpClient: HttpClient) { }

  areThereDetailsWithQuantity0(id: number): Observable<boolean> {
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryTransferDetail.AreThereDetailsWithQuantity0}/${id}`);
  }

  createInventoryTransferDetail(inventoryTransferDetailModel: InventoryTransferDetailModel): Observable<InventoryTransferDetailModel> {
    return this._httpClient.post<InventoryTransferDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryTransferDetail.CreateInventoryTransferDetail}`,
      inventoryTransferDetailModel);
  }

  createSomeDetails(rentalStocks: Array<RentalStockModalModel>, inventoryTransferId: number): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryTransferDetail.CreateSomeDetails}/${inventoryTransferId}`,
      rentalStocks);
  }

  deleteInventoryTransferDetail(inventoryTransferDetailId: number): Observable<InventoryTransferDetailModel> {
    return this._httpClient.delete<InventoryTransferDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryTransferDetail.DeleteInventoryTransferDetail}/${inventoryTransferDetailId}`);
  }

  deleteSomeDetails(inventoryTransferDetailIds: number[]): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryTransferDetail.DeleteSomeDetails}`,
      inventoryTransferDetailIds);
  }

  exportDetailConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams()
      .set('columnSort', columnSort ?? '')
      .set('ascendant', ascendant.toString());

    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryTransferDetail.ExportDetailConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getArticlesForDetailsAsync(inventoryTransferId: number, page: number, limit: number,
    columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<RentalStockModalModel>> {
    const params = new HttpParams().set('inventoryTransferId', inventoryTransferId).set('page', page).set('limit', limit)
      .set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<RentalStockModalModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryTransferDetail.GetArticlesForDetailsAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForArticles(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryTransferDetail.GetColumnsForArticlesAsync}`);
  }

  getColumnsForCaptureTable(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryTransferDetail.GetColumnsForCaptureTableAsync}`);
  }

  getColumnsForDetailConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryTransferDetail.GetColumnsForDetailConsultationAsync}`);
  }

  getDetailsForCaptureTable(page: number, limit: number, columnSort: string | null, ascendant: boolean, inventoryTransferId: number): Observable<PagedResponseModel<InventoryTransferDetailCaptureTableModel>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant)
      .set('inventoryTransferId', inventoryTransferId);

    return this._httpClient.get<PagedResponseModel<InventoryTransferDetailCaptureTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryTransferDetail.GetDetailsForCaptureTableAsync}`,
      { params: params }
    );
  }

  getInventoryTransferDetailById(id: number): Observable<InventoryTransferDetailModel> {
    return this._httpClient.get<InventoryTransferDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryTransferDetail.GetInventoryTransferDetailById}/${id}`);
  }

  getInventoryTransferDetailByKeys(inventoryTransferId: number, articleId: number): Observable<InventoryTransferDetailModel> {
    const params = new HttpParams().set('inventoryTransferId', inventoryTransferId).set('articleId', articleId);
    return this._httpClient.get<InventoryTransferDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryTransferDetail.GetInventoryTransferDetailByKeys}`,
      { params: params });
  }

  getInventoryTransferDetailsForDetailConsultation(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<InventoryTransferDetailTableModel>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<InventoryTransferDetailTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryTransferDetail.GetInventoryTransferDetailsForDetailConsultation}`,
      filters, { params: params }
    );
  }

  updateInventoryTransferDetail(inventoryTransferDetailContractModel: InventoryTransferDetailModel): Observable<InventoryTransferDetailModel> {
    return this._httpClient.put<InventoryTransferDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryTransferDetail.UpdateInventoryTransferDetail}`,
      inventoryTransferDetailContractModel);
  }
}
